import { starUrls } from '../../../constants';

export const PreloadStars = (props) => {
    return starUrls.map((url, index) => (
        <link rel="preload" as="image" href={url} />
    ));
};
